// test156
(156 && 0);
